import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as zc from '@dvsl/zoomcharts';

@Component({
  selector: 'app-geochart',
  templateUrl: './geochart.component.html',
  styleUrls: ['./geochart.component.css']
})
export class GeochartComponent implements AfterViewInit {

  @Input() chartID: string;
  @Input() settings: string;
  zc: any = zc;
  chart: any;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const GeoChart = this.zc.GeoChart;
    this.chart = new GeoChart(this.settings);
  }

}
